import { SQSPocketResponse } from '@models/MLTC/SQSPocketRequest.model';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface Step2State {
  planSelection: any;
  coverageTerm: any;
  monthlyBenefitsAmountSelection: any;
  hasHydratedMonthlyBenefit: boolean;
  appliedPromoCode: string;
  quoteRawRequest: any | null;
  quoteRawResponse: any | null;
  isCompleted: boolean;
  sqsQuotation: SQSPocketResponse | null;
  isEligible: boolean;
  planOverview: any;
  transactionId: string;
  promoPercentage:number;
  confirmQuotation: boolean;
  planDetails: any;
  gioNricDetails: string;
  gioDeclaration: string;
  cstopupCampaignValidity: boolean;
}

const initialState: Step2State = {
  planSelection: null,
  coverageTerm: null,
  monthlyBenefitsAmountSelection: null,
  hasHydratedMonthlyBenefit: false,
  appliedPromoCode: '',
  quoteRawRequest: null,
  isCompleted: false,
  quoteRawResponse: null,
  sqsQuotation: null,
  isEligible: false,
  transactionId:"",
  planOverview: null,
  promoPercentage: 0,
  confirmQuotation: false,
  planDetails: null,
  gioNricDetails: "",
  gioDeclaration: "",
  cstopupCampaignValidity: false,
};

const step2Slice = createSlice({
  name: "MLTC-R3-Step2",
  initialState,
  reducers: {
    updateTransactionId: (state, action) => {
      state.transactionId = action.payload;
    },
    updatePlanSelection: (state, action) => {
      state.planSelection = action.payload;
      console.log("Update plan selesction reducer", state.planSelection);
    },
    updateCoverageTerm: (state, action) => {
      state.coverageTerm = action.payload;
      console.log("Update coverage term reducer", state.coverageTerm);
    },
    updateMonthlyBenefitsAmountSelection: (state, action) => {
      state.monthlyBenefitsAmountSelection = action.payload;
      // console.log("Update monthly benefits amount reducer",state.monthlyBenefitsAmountSelection);
    },
    setHasHydratedMonthlyBenefit(state, action) {
      state.hasHydratedMonthlyBenefit = action.payload;
    },
    updatePromoCode: (state, action) => {
      state.appliedPromoCode = action.payload;
      console.log("Update promo code reducer", state.appliedPromoCode);
    },
    updateQuoteRequest: (state, action: PayloadAction<object>) => {
      state.quoteRawRequest = action.payload;
    },
    completeStep: (state, action: PayloadAction<boolean>) => {
      state.isCompleted = action.payload;
    },
    updateSQSQuotation: (
      state,
      action: PayloadAction<SQSPocketResponse | null>,
    ) => {
      state.sqsQuotation = action.payload;
    },
    updateQuoteResponse: (state, action: PayloadAction<object>) => {
      state.quoteRawResponse = action.payload;
    },
    updateEligible: (state, action: PayloadAction<boolean>) => {
      state.isEligible = action.payload;
    },
    updatePlanOverview: (state, action: PayloadAction<any>) => {
      state.planOverview = action.payload;
    },
    confirmQuotation: (state, action: PayloadAction<boolean>) => {
      state.confirmQuotation = action.payload;
    },
    updatePercentage: (state, action: PayloadAction<number>) => {
      state.promoPercentage = action.payload;
    },
    updatePlanDetails: (state, action: PayloadAction<any>) => {
      state.planDetails = action.payload;
    },
    updateGIONRICDetails: (state, action) => {
      state.gioNricDetails = action.payload;
    },
    updateGIODeclaration: (state, action) => {
      state.gioDeclaration = action.payload;
    },
    updateCSTOPUPCampaignValidity: (state, action) => {
      state.cstopupCampaignValidity = action.payload;
    },
  },
  extraReducers: {},
});

export const {
  updatePlanSelection,
  updateCoverageTerm,
  updateMonthlyBenefitsAmountSelection,
  updateQuoteRequest,
  updatePromoCode,
  completeStep,
  updateSQSQuotation,
  updateQuoteResponse,
  updateEligible,
  updatePlanOverview,
  confirmQuotation,
  updatePercentage,
  updatePlanDetails,
  updateTransactionId,
  updateGIONRICDetails,
  updateGIODeclaration,
  updateCSTOPUPCampaignValidity,
  setHasHydratedMonthlyBenefit
} = step2Slice.actions;

export default step2Slice.reducer;
